"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Points_1 = __importDefault(require("./Points"));
const getRange = (points) => {
    switch (true) {
        case points >= 90:
            return 'Very Secure';
        case points >= 80:
            return 'Secure';
        case points >= 70:
            return 'Very Strong';
        case points >= 60:
            return 'Strong';
        case points >= 50:
            return 'Average';
        case points >= 25:
            return 'Weak';
        case points >= 0:
            return 'Very Weak';
        default:
            return '';
    }
};
const checkStrength = (password, validSymbolsChars) => {
    const points = new Points_1.default(password, validSymbolsChars).getAll();
    const range = getRange(points);
    return { points, range };
};
exports.default = checkStrength;
